import type { JournalEntry } from '@/platform/localStore'
import { ENGINE_VERSION } from '../domain/engine'
import type { EngineEvent } from '../domain/types'

// Du moteur au journal local : chaque événement reçoit l'identifiant que le serveur dédupliquera. Une terminaison
// AUTO du moteur porte en plus la résidence à terminer; l'envoi n'a lieu qu'en mode AUTO du serveur.

export interface JournalContext {
  missionId: string
  /** Mode figé par le serveur au départ (jamais le profil de calibration locale). */
  serverMode: 'OFF' | 'OBSERVATION' | 'AUTO'
  uuid: () => string
}

function itemIdOf(event: EngineEvent): string | null {
  return 'itemId' in event ? event.itemId : null
}

export function toJournalEntries(events: readonly EngineEvent[], context: JournalContext): JournalEntry[] {
  if (context.serverMode === 'OFF') return []
  return events.map((event) => {
    const { kind, at, ...rest } = event
    const itemId = itemIdOf(event)
    const { itemId: _itemId, ...payload } = rest as Record<string, unknown>
    void _itemId
    const autoCompletion = event.kind === 'COMPLETED' && event.source === 'AUTO' && context.serverMode === 'AUTO'
    return {
      id: context.uuid(),
      missionId: context.missionId,
      occurredAt: new Date(at).toISOString(),
      itemId,
      kind,
      engineVersion: ENGINE_VERSION,
      payload,
      completeItemId: autoCompletion ? itemId : null,
    }
  })
}
